// src/layouts/MainLayout.jsx
import { Outlet } from "react-router-dom";
import NavBar from "../components/NavBar";
import ContentWrapper from "./ContentWrapper";

export default function MainLayout() {
  return (
    <>
      <NavBar />
      <ContentWrapper>
        <Outlet /> {/* renders child routes */}
      </ContentWrapper>
    </>
  );
}
